import { render, staticRenderFns } from "./medkon_score_card.vue?vue&type=template&id=6fd7551e&"
import script from "./medkon_score_card.vue?vue&type=script&lang=js&"
export * from "./medkon_score_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports